import { render } from "./NovncConsoleCustomKeys.vue?vue&type=template&id=8dc01b06&scoped=true"
import script from "./NovncConsoleCustomKeys.vue?vue&type=script&lang=js"
export * from "./NovncConsoleCustomKeys.vue?vue&type=script&lang=js"

import "./NovncConsoleCustomKeys.vue?vue&type=style&index=0&id=8dc01b06&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dc01b06"]])

export default __exports__